// extracted by mini-css-extract-plugin
export default {"component":"Badge_component__jQKFy","confirmVariant":"Badge_confirmVariant__VfFRd","defaultVariant":"Badge_defaultVariant__S2SxJ"};